exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".delete_icon{\r\n    width:30px;\r\n    height:30px;\r\n    cursor:pointer;\r\n}\r\n.disable_delete_icon{\r\n\twidth:30px;\r\n    height:30px;\r\n\tpointer-events:none;\r\n\tmargin-right:6px;\r\n\tmargin-left:6px;\r\n\topacity: 0.3;\r\n}", ""]);

